<div class="association-search-list" [ngStyle]="{'display':loadSearchResult ? 'block' : 'none' }">
  <div class="py-2 px-3 border-bottom align-items-center justify-content-start" *ngIf="searchResult">
    <div [ngStyle]="{'display':selectedNodeIds && selectedNodeIds.length>0 ? 'block' : 'none' }">
      <app-select-association #selectAssociation (removeOptions)="removeCopiedOptions($event);"
        [viewLocation]="'searchList'" (associationsObj)="updateAssociationsObj($event);"
        (settingsModalOpen)="selectOptions($event);" [optionsToCopySaved]="optionsToCopySaved" [isCopy]="isCopy"
        [isCopyAssociation]="isCopyAssociation" [displayText]="displayText" [displayOption]="displayOption"
        [currentTab]="currentTab"></app-select-association>
    </div>

    <div *ngIf="!selectedNodeIds || selectedNodeIds.length===0" role="alert" aria-live="polite">
      <p class="pr-3 mb-0 d-inline-block"  >{{searchResult.length}} Results</p>
      <button class="btn btn-clear text-underline btn-sm" type="button" tabindex="1" (click)="resetSearch();">Reset Search</button>
    </div>
  </div>




  <div class="py-2 px-3 border-bottom row mx-0 justify-content-between align-items-start"
    *ngFor="let searchItem of searchResult | slice:startIndex:lastIndex; let i = index ">
    <div class="col-12 custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="{{'custom-check-'+searchItem.unique_node_id}}"
        [disabled]="searchItem['type'][0] === 'document' && disableDocument? true:false"
        (click)="searchItem.isChecked = !searchItem.isChecked;updatedSelection(searchItem.unique_node_id,searchItem.isChecked);">
      <label class="custom-control-label custom-control-checkbox position-absolute"
        for="{{'custom-check-'+searchItem.unique_node_id}}"></label>
      <button class="btn btn-clear btn-sm p-1 text-wrapped text-left" *ngIf="searchItem['type'][0] === 'document'"
        (click)="navigateToTaxonomy(searchItem);">{{searchItem.taxonomy_name}}
      </button>
      <button class="btn btn-clear btn-sm p-1 text-wrapped text-left" *ngIf="searchItem['type'][0] === 'item'"
        (click)="navigateToTaxonomy(searchItem);">
        <ng-container *ngIf="searchItem.human_coding_scheme">
          {{searchItem.human_coding_scheme + ' '}}
        </ng-container>
        <ng-container *ngIf="searchItem.full_statement"><span [innerHTML]="searchItem.full_statement"></span></ng-container>
      </button>
      <div class="col-12 pl-2">
        <ul class="m-0 p-0 bread-crumb">
          <li class="active font-size-14" [innerHtml]="searchItem.taxonomy_name"></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="px-2">
    <app-pagination *ngIf="searchResult !== undefined && (searchResult && searchResult.length > minItemPerPage)"
      [dataLength]="searchResult ? searchResult.length : 0" (displayItemRangeEvent)="showDataInRange($event)">
    </app-pagination>
  </div>
</div>
